import React from "react";
import resolveMediaUrl from "util/resolveMediaUrl";

const ViewModal = props => {
  const { data } = props;
  const imageSrc = resolveMediaUrl(data?.sliderImage);

  return (
    <div>
      <form>
        <div className="d-flex">
          {imageSrc && (
            <div className="form-group">
              <div>
                <div id="item_icon pa-8">
                  <img
                    className="top-header-profile-class view-image"
                    src={imageSrc}
                    alt="Slider preview"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="col-6 pt-2">
          <div className="form-group">
            <label className="fs-16 medium-text">
              Slider Link&nbsp;:&nbsp;
            </label>
            <div className="breakWord">{data.sliderLink ?? "-"}</div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ViewModal;
